import React from "react";
import { format } from "date-fns";
import { Table } from "semantic-ui-react";
import _ from "lodash";

export default function HistoryListItem({ entry }) {
  return (
    <Table.Row key={entry.id}>
      <Table.Cell>
        {format(new Date(entry.createdAt), "MM/dd/yyyy h:mm a")}
      </Table.Cell>
      <Table.Cell>
        {_.capitalize(entry.role)}
        {entry.hasPoa && " POA"}
      </Table.Cell>
      <Table.Cell>
        {entry.hasPoa && entry.poaFullName
          ? entry.poaFullName
          : `${entry.firstName} ${entry.lastName}`}
      </Table.Cell>
      <Table.Cell>{entry.action}</Table.Cell>
      <Table.Cell>{entry.document}</Table.Cell>
      <Table.Cell>
        {_.capitalize(entry.toRole)}
        {entry.toHasPoa && " POA"}
      </Table.Cell>
      <Table.Cell>
        {entry.toHasPoa && entry.toPoaFullName
          ? entry.toPoaFullName
          : `${entry.toFirstName} ${entry.toLastName}`}
      </Table.Cell>
      <Table.Cell>{entry.toEmail}</Table.Cell>
    </Table.Row>
  );
}
